import { Injectable, inject } from '@angular/core';
import { EventDto } from '@simOn/event/element/models';
import { BehaviorSubject, Observable, catchError, map, of, shareReplay, switchMap } from 'rxjs';
import { EventsApiService } from './events-api.service';

@Injectable({ providedIn: 'root' })
export class EventMarkersService {
  private readonly _api = inject(EventsApiService);
  private readonly _refresh$ = new BehaviorSubject<void>(undefined);

  readonly events$: Observable<EventDto[]> = this._refresh$.pipe(
    switchMap(() => this._api.getEvents().pipe(catchError(() => of([] as EventDto[])))),
    map((events) => events.filter((event) => !!event.transformation?.position)),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  refresh(): void {
    this._refresh$.next();
  }
}
